import React from 'react';

const Step3Education = ({ 
  formData, 
  formErrors, 
  handleEducationChange, 
  addEducation, 
  removeEducation, 
  handleEducationFileUpload, 
  handleRemoveFile, 
  isSubmitting,
  isOtpStep,
  handleChange
}) => {
  
  const getEducationLabel = (level) => {
    const labels = {
      '8th': '8th Standard',
      '10th': '10th Standard',
      '12th': '12th Standard',
      'undergraduate': 'Undergraduate',
      'postgraduate': 'Post Graduate',
      'phd': 'PhD',
      'diploma': 'Diploma',
      'other': 'Other'
    };
    return labels[level] || level || 'Education';
  };

  const isSchoolLevel = (level) => {
    return ['8th', '10th', '12th'].includes(level);
  };

  return (
    <>
      
      <div className="education-section">
        {formData.educationList.map((edu, index) => (
          <div key={edu.id} className={`education-entry ${isSchoolLevel(edu.educationLevel) ? 'school-education' : 'higher-education'}`}>
            <div className="education-header">
              <h4>{getEducationLabel(edu.educationLevel)} {!isSchoolLevel(edu.educationLevel) && `#${index + 1}`}</h4>
              <button
                type="button"
                className="remove-education-btn"
                onClick={() => removeEducation(index)}
                disabled={isSubmitting}
              >
                ✕ Remove
              </button>
            </div>

            <div className="education-fields">
              <div className="application-field">
                <label htmlFor={`eduLevel-${index}`}>Education Level <span className="required-star">*</span></label>
                <select
                  id={`eduLevel-${index}`}
                  value={edu.educationLevel}
                  onChange={(e) => handleEducationChange(index, 'educationLevel', e.target.value)}
                  disabled={isSubmitting}
                >
                  <option value="">Select Education Level</option>
                  <option value="8th">8th Standard</option>
                  <option value="10th">10th Standard</option>
                  <option value="12th">12th Standard</option>
                  <option value="undergraduate">Undergraduate</option>
                  <option value="postgraduate">Post Graduate</option>
                  <option value="phd">PhD</option>
                  <option value="diploma">Diploma</option>
                  <option value="other">Other</option>
                </select>
                {formErrors.educationList?.[index]?.educationLevel && (
                  <p className="application-error">{formErrors.educationList[index].educationLevel}</p>
                )}
              </div>

              {isSchoolLevel(edu.educationLevel) ? (
                // ===== SCHOOL LEVEL FIELDS (8th, 10th, 12th) =====
                <>
                  <div className="application-field">
                    <label htmlFor={`board-${index}`}>Board Name <span className="required-star">*</span></label>
                    <input
                      id={`board-${index}`}
                      value={edu.board || ''}
                      onChange={(e) => handleEducationChange(index, 'board', e.target.value)}
                      placeholder="Enter board name"
                      disabled={isSubmitting}
                    />
                    {formErrors.educationList?.[index]?.board && (
                      <p className="application-error">{formErrors.educationList[index].board}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`schoolPercentage-${index}`}>Percentage <span className="required-star">*</span></label>
                    <input
                      id={`schoolPercentage-${index}`}
                      value={edu.percentage || ''}
                      onChange={(e) => handleEducationChange(index, 'percentage', e.target.value)}
                      placeholder="e.g., 85.5"
                      disabled={isSubmitting}
                    />
                    {formErrors.educationList?.[index]?.percentage && (
                      <p className="application-error">{formErrors.educationList[index].percentage}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`schoolYear-${index}`}>Year of Passing <span className="required-star">*</span></label>
                    <input
                      id={`schoolYear-${index}`}
                      value={edu.yearOfPassing || ''}
                      onChange={(e) => handleEducationChange(index, 'yearOfPassing', e.target.value)}
                      placeholder="YYYY"
                      maxLength="4"
                      disabled={isSubmitting}
                    />
                    {formErrors.educationList?.[index]?.yearOfPassing && (
                      <p className="application-error">{formErrors.educationList[index].yearOfPassing}</p>
                    )}
                  </div>
                </>
              ) : (
                // ===== HIGHER EDUCATION FIELDS =====
                <>
                  <div className="application-field">
                    <label htmlFor={`university-${index}`}>University <span className="required-star">*</span></label>
                    <input
                      id={`university-${index}`}
                      value={edu.university || ''}
                      onChange={(e) => handleEducationChange(index, 'university', e.target.value)}
                      placeholder="Enter university name"
                      disabled={isSubmitting}
                    />
                    {formErrors.educationList?.[index]?.university && (
                      <p className="application-error">{formErrors.educationList[index].university}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`college-${index}`}>College <span className="required-star">*</span></label>
                    <input
                      id={`college-${index}`}
                      value={edu.college || ''}
                      onChange={(e) => handleEducationChange(index, 'college', e.target.value)}
                      placeholder="Enter college name"
                      disabled={isSubmitting}
                    />
                    {formErrors.educationList?.[index]?.college && (
                      <p className="application-error">{formErrors.educationList[index].college}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`courseName-${index}`}>Course Name <span className="required-star">*</span></label>
                    <input
                      id={`courseName-${index}`}
                      value={edu.courseName || ''}
                      onChange={(e) => handleEducationChange(index, 'courseName', e.target.value)}
                      placeholder="Enter course name"
                      disabled={isSubmitting}
                    />
                    {formErrors.educationList?.[index]?.courseName && (
                      <p className="application-error">{formErrors.educationList[index].courseName}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`courseType-${index}`}>Course Type <span className="required-star">*</span></label>
                    <select
                      id={`courseType-${index}`}
                      value={edu.courseType || ''}
                      onChange={(e) => handleEducationChange(index, 'courseType', e.target.value)}
                      disabled={isSubmitting}
                    >
                      <option value="">Select Course Type</option>
                      <option value="1">Regular</option>
                      <option value="2">Distance/Open</option>
                      {/* <option value="Part Time">Part Time</option> */}
                    </select>
                    {formErrors.educationList?.[index]?.courseType && (
                      <p className="application-error">{formErrors.educationList[index].courseType}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`higherPercentage-${index}`}>Percentage <span className="required-star">*</span></label>
                    <input
                      id={`higherPercentage-${index}`}
                      value={edu.percentage || ''}
                      onChange={(e) => handleEducationChange(index, 'percentage', e.target.value)}
                      placeholder="e.g., 85.5"
                      disabled={isSubmitting}
                    />
                    {formErrors.educationList?.[index]?.percentage && (
                      <p className="application-error">{formErrors.educationList[index].percentage}</p>
                    )}
                  </div>

                  <div className="application-field">
                    <label htmlFor={`higherYear-${index}`}>Year of Passing <span className="required-star">*</span></label>
                    <input
                      id={`higherYear-${index}`}
                      value={edu.yearOfPassing || ''}
                      onChange={(e) => handleEducationChange(index, 'yearOfPassing', e.target.value)}
                      placeholder="YYYY"
                      maxLength="4"
                      disabled={isSubmitting}
                    />
                    {formErrors.educationList?.[index]?.yearOfPassing && (
                      <p className="application-error">{formErrors.educationList[index].yearOfPassing}</p>
                    )}
                  </div>
                </>
              )}
            </div>

            {/* ===== UPLOAD DOCUMENTS SECTION ===== */}
            <div className="upload-documents-section full-width">
              <h5>Upload Documents</h5>
              <div className="upload-row">
                <div className="application-field">
                  <label>Marksheet <span className="required-star">*</span></label>
                  <div className={`upload-area ${edu.marksheet ? 'has-file' : ''}`}>
                    <input
                      id={`marksheet-${index}`}
                      type="file"
                      accept=".jpg,.jpeg,.png,.pdf"
                      onChange={(e) => handleEducationFileUpload(index, 'marksheet', e)}
                      disabled={isSubmitting}
                    />
                    {edu.marksheet ? (
                      <div className="file-selected">
                        <span className="file-name">📄 {edu.marksheet}</span>
                        <div className="file-actions">
                          <button 
                            type="button" 
                            className="update-file"
                            onClick={() => { document.getElementById(`marksheet-${index}`).click(); }}
                          >
                            Update
                          </button>
                          <button 
                            type="button" 
                            className="remove-file"
                            onClick={() => handleRemoveFile(index, 'marksheet')}
                          >
                            ✕
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <p>Click or Drag file to upload</p>
                        <span className="file-types">JPG, PNG, PDF</span>
                      </>
                    )}
                  </div>
                  {formErrors.educationList?.[index]?.marksheet && (
                    <p className="application-error">{formErrors.educationList[index].marksheet}</p>
                  )}
                </div>

                {/* Certificate - Not for 8th Standard */}
                {edu.educationLevel !== '8th' && (
                  <div className="application-field">
                    <label>Certificate <span className="required-star">*</span></label>
                    <div className={`upload-area ${edu.certificate ? 'has-file' : ''}`}>
                      <input
                        id={`certificate-${index}`}
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={(e) => handleEducationFileUpload(index, 'certificate', e)}
                        disabled={isSubmitting}
                      />
                      {edu.certificate ? (
                        <div className="file-selected">
                          <span className="file-name">📄 {edu.certificate}</span>
                          <div className="file-actions">
                            <button 
                              type="button" 
                              className="update-file"
                              onClick={() => { document.getElementById(`certificate-${index}`).click(); }}
                            >
                              Update
                            </button>
                            <button 
                              type="button" 
                              className="remove-file"
                              onClick={() => handleRemoveFile(index, 'certificate')}
                            >
                              ✕
                            </button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <p>Click or Drag file to upload</p>
                          <span className="file-types">JPG, PNG, PDF</span>
                        </>
                      )}
                    </div>
                    {formErrors.educationList?.[index]?.certificate && (
                      <p className="application-error">{formErrors.educationList[index].certificate}</p>
                    )}
                  </div>
                )}
              </div>
              
              {/* 8th Standard Info message */}
              {edu.educationLevel === '8th' && (
                <p className="info-message">Certificate is not required for 8th Standard. Only Marksheet is required.</p>
              )}
            </div>
          </div>
        ))}

        <div className="add-education-wrapper">
          <button
            type="button"
            className="add-education-btn"
            onClick={addEducation}
            disabled={isSubmitting}
          >
            + Add Education
          </button>
        </div>
      </div>

      {isOtpStep && (
        <div className="application-field otp-field full-width">
          <label htmlFor="otp">OTP Verification <span className="required-star">*</span></label>
          <input
            id="otp"
            name="otp"
            value={formData.otp}
            onChange={handleChange}
            placeholder="Enter OTP sent to your email"
            disabled={isSubmitting}
          />
          {formErrors.otp && <p className="application-error">{formErrors.otp}</p>}
        </div>
      )}
    </>
  );
};

export default Step3Education;